import { useQuery } from 'react-query';
import { TypeInsuranceFields } from 'types/contentful';
import ContentService from 'utils/contentful/contentfulService';
import { StateAbbrev, toStateAbbrev } from 'utils/states';

export type InsuranceDefinitionV2 = Omit<TypeInsuranceFields, 'state'> & {
  displayName: string;
  state: StateAbbrev;
  /** Can be used as unique identifier */
  entryId: string;
  isDefaultEstimates?: boolean;
};

export const getInsuranceV2Options = async () => {
  const insuranceData = await ContentService.clients.expressable.getEntries<TypeInsuranceFields>({
    content_type: 'insurance',
    limit: 1000,
    'fields.accessibleByClients': true,
  });

  const parsedInsurances: InsuranceDefinitionV2[] = [];

  insuranceData.items.forEach(rawInsurance => {
    if (!rawInsurance.fields.insuranceType) {
      // @TODO until bad data is fixed
      return;
    }
    const {
      fields: { friendlyPayerName, state, insuranceType },
    } = rawInsurance;
    const name = insuranceType === 'Commercial' ? friendlyPayerName : `${friendlyPayerName} (${insuranceType})`;

    if (!state) {
      // @TODO until bad data is fixed
      return;
    }
    parsedInsurances.push({
      ...rawInsurance.fields,
      displayName: name.trim(),
      state: toStateAbbrev(state),
      entryId: rawInsurance.sys.id,
      candidPayerName: rawInsurance.fields.candidPayerName.trim(),
      friendlyPayerName: rawInsurance.fields.friendlyPayerName.trim(),
      insuranceName: rawInsurance.fields.insuranceName.trim(),
      payerId: rawInsurance.fields.payerId.trim().toUpperCase(),
      eligibilityPayerIdOverride: rawInsurance.fields.eligibilityPayerIdOverride?.trim().toUpperCase(),
      intakeRequirements: rawInsurance.fields.intakeRequirements?.trim(),
      cptExclusionDetail: rawInsurance.fields.cptExclusionDetail?.trim(),
      icdExclusionDetail: rawInsurance.fields.icdExclusionDetail?.trim(),
    });
  });

  return parsedInsurances;
};

export const useInsurancesV2 = () => {
  return useQuery(['insurance-options-v2'], getInsuranceV2Options);
};
